import DailyForecast from "./DailyForecast";
import MonthlyForecast from "./MonthlyForecast";

const Daily = () => {
  return (
    <>
      <MonthlyForecast />
      <DailyForecast />
    </>
  );
};

export default Daily;
